import React, { useState, useEffect , useContext } from "react";
import axios from "axios";
import {
    TextField,
    Paper,
    Box,
    AppBar,
    Toolbar,
    Typography,
    Button,
    Alert,
    Chip,
    Rating,

} from "@mui/material"

import Header from "../Header";
import {
    GridPagination,
    DataGrid,
  } from '@mui/x-data-grid';
import { PatternFormat } from "react-number-format";

const formatDate = (value) => {
    if (!value) return "—";
    return new Date(value).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
};

const RatingCell = (params) => {
    if (params.value === null || params.value === undefined) {
        return <Typography variant="body2" color="text.secondary">—</Typography>;
    }
    return <Rating value={params.value} readOnly size="small" />;
};

const RecommendCell = (params) => {
    if (!params.value) {
        return <Typography variant="body2" color="text.secondary">—</Typography>;
    }
    const isYes = params.value === "yes";
    return (
        <Chip
            label={isYes ? "Yes" : "No"}
            size="small"
            color={isYes ? "success" : "error"}
            variant="outlined"
        />
    );
};

const FeedbackReport=()=>{
    const [reportSummary, setReportSummary] = useState([])
    
    const url=process.env.REACT_APP_SERVER_URL;
    useEffect(() => {
        getAllCustomerInqueries();
      
    }, []);
    const columns=[
        { field: 'id', headerName: 'FeedbackID', width: 120, align: 'left' },
        { field: 'name', headerName: 'Customer Name', width: 200, align: 'left' },
        { field: 'phoneNumber', headerName: 'Phone Number', width: 160, align: 'left',
            renderCell:(params)=>{
            const currentRow=params.row;
            return <>
            <PatternFormat value={currentRow.phoneNumber} format="(###) ###-####"
        mask="_"  displayType="text" />
            </>
            
           } },
        { field: 'roomNumber', headerName: 'Room #', width: 100, align: 'left',
            renderCell: (params) => params.value || "—" },
        { field: 'stayFrom', headerName: 'Check-in', width: 130, align: 'left',
            renderCell: (params) => formatDate(params.value) },
        { field: 'stayTo', headerName: 'Check-out', width: 130, align: 'left',
            renderCell: (params) => formatDate(params.value) },
        { field: 'overallStayRating', headerName: 'Overall Stay', width: 160, align: 'left',
            renderCell: RatingCell },
        { field: 'roomCleanRating', headerName: 'Room Clean', width: 160, align: 'left',
            renderCell: RatingCell },
        { field: 'happyWithStayRating', headerName: 'Happy With Stay', width: 160, align: 'left',
            renderCell: RatingCell },
        { field: 'managementTreatmentRating', headerName: 'Management Treatment', width: 190, align: 'left',
            renderCell: RatingCell },
        { field: 'recommend', headerName: 'Would Recommend', width: 160, align: 'left',
            renderCell: RecommendCell },
        { field: 'feedback', headerName: 'Feedback', width: 400, align: 'left',
            renderCell: (params) => params.value || "—" },


    ];
    const getAllCustomerInqueries = async()=>{
    try{
        const response=await axios.get(`${url}/customerInqueries`);
        if(response && response.data){
            console.log(response.data)
            setReportSummary(response.data);
        }

    }
    catch(error){
        console.log(error)
    }
    }

    
    

    return (
      <>
      <Header/>
      <Box
        sx={{
          height: 450,
          width: '100%',
          '& .actions': {
            color: 'text.secondary',
          },
          '& .textPrimary': {
            color: 'text.primary',
          },
        }}
      >
        <DataGrid rows={reportSummary} columns={columns}
        getRowId={(row) => row.id}
        />
        
      </Box>
      
      </>
    );


}
export default FeedbackReport;